import React from "react";
import { Box } from "@mui/material";

const defaultContainerSx = {
  width: "100%",
  maxWidth: 1200,
  minWidth: 0,
  mx: "auto",
  px: {
    xs: 2,
    sm: 2,
    md: 3,
    lg: 5,
    xl: 6
  },
  boxSizing: "border-box"
};

export default function AdminPageContainer({ children, sx = {} }) {
  return <Box sx={{ ...defaultContainerSx, ...sx }}>{children}</Box>;
}
